export default __webpack_public_path__ + "static/media/278.aea5ee33.jpg";